import { EditOutlined , EyeOutlined , FieldTimeOutlined , PrinterOutlined} from "@ant-design/icons";
import { Button, Table , Space, Drawer, List, Avatar, Row, Col, Switch, Card, Descriptions, Tag } from 'antd';

import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import ProgrammeService from "../../api/programme.service";
import commonUtility from "../../utility/Utils";
import CustomTableSearch from "../common/CustomTableSearch";
import TapBookingGeneratedSchedule from "./TapBookingGeneratedSchedule";

const TapBookingListView = (props) => {
    const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
    const [page, setPage] = React.useState(1);

    const [paymentPaidList, setPaymentPaidList] = useState([]);
    const [bookingTimeSlotList, setBookingTimeSlotList] = useState([]);
    const [bookingTimeSlotListDetailView, setBookingTimeSlotListDetailView] = useState([]);
    const [visible, setVisible] = useState(false);
    const [filteredSearchList, setFilteredSearchList] = useState([]);

    const [memberName, setMemberName] = useState("");
    const [memberMobileNo, setMemberMobileNo] = useState("");
    const [receiptNo, setReceiptNo] = useState("");
    const [bookingValidity, setBookingValidity] = useState("");

    let navigate = useNavigate();

    function changeLocation(placeToGo) {
        navigate(placeToGo, { replace: true });
        window.location.reload();
    }

    const pageSize = 10; 

    const pagination = {
      current: page, 
      pageSize: pageSize, 
    };

    const columns = [
      { 
        title: '#', 
        dataIndex: 'index', 
        render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
        width: '5%',
      },
      {
        title: 'Adult/Special',
        dataIndex: 'tap_group',
        key: 'tap_group',
        sorter: (a, b) => (a.tap_group ?? '').localeCompare(b.tap_group ?? ''),
        render: (selectedObj,record) => (
          <Space size="middle">
            {
              record.tap_group == "TAPM" ? <><Tag>Adult Coaching</Tag></> : <></>
            }
            {
              record.tap_group == "TAPSC" ? <><Tag>Special Coaching</Tag></> : <></>
            }
          </Space>
        )
      },
      {
        title: 'Name',
        dataIndex: 'member_fname',
        key: 'member_fname',
        render: (selectedObj,values) => (
          <>{values.member_fname} {values.member_lname} </>
        ),
        
        
      },
     
      {
        title: 'Mobile',
        dataIndex: 'primary_mobile',
        key: 'primary_mobile',
      },
      {
        title: 'Receipt No',
        dataIndex: 'receipt_no',
        key: 'receipt_no',
        
      },
      {
        title: 'Receipt Date',
        dataIndex: 'receipt_date',
        key: 'receipt_date',
        render: (selectedObj,values) => (
            <>{commonUtility.dateFormatDDMMYYYY(new Date(values.receipt_date),"/")} </>
          ),
      },
      
      {
        title: 'Booking Validity',
        dataIndex: 'tap_end_date',
        key: 'tap_end_date',
        render: (selectedObj,values) => (
            <>
              <div style={{fontStyle:'italic',fontWeight:'700'}} >{values.tap_start_date} to {values.tap_end_date} </div>
            </>
          ),
      },
      {
          title: 'Paid Amount',
          dataIndex: 'payment_amount',
          key: 'payment_amount',
          render: (selectedObj,values) => (
            <div align="right">{ commonUtility.sanitizeValue(values.payment_amount).toFixed(2)} </div>
          ),

        },
  
        {
          title: 'Bill Type',
          dataIndex: 'bill_type',
          key: 'bill_type',
         

        },
      
    
      {
        title: 'Action',
        key: 'action',
        render: (selectedObj) => (
          
          <Space size="middle">
            
            <Button title="Schedule" htmlType="button" type="primary" size="small" shape="" onClick={()=> showDrawer(selectedObj)}><FieldTimeOutlined /></Button>
               
            <Link to={`/tap/booking/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`}>
              <Button htmlType="button" type="ghost" size="small" shape="" danger ><EditOutlined /></Button>
            </Link>

            {/* <Link to={`http://btaportal.in/custom/report/tap/printpdf/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`}>
              <Button htmlType="button" type="ghost" size="small" shape="" danger ><EditOutlined /></Button>
            </Link> */}
            <a href={`http://btaportal.in/custom/report/tap/printpdf/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} target="_blank" rel="noopener noreferrer">
              <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /> Print</Button>
            </a>



          </Space>
        ),
      },


    ];
  
  
    const onClose = () => {
        setVisible(false);
      };
    
    const showDrawer = (rowdata) => {
    

        //const data = { formdata: values };
        const data = {formdata : {
            receipt_id : rowdata.receipt_id,
            enrollment_id : rowdata.enrollment_id,
        }}


        ProgrammeService.tapBookingDetailList(data).then((res) => {

       
            
            if(commonUtility.sanitizeObject(res)) {
                setMemberName(`${rowdata.member_fname} ${rowdata.member_lname}`)
                setMemberMobileNo(`${rowdata.primary_mobile}`)
                setReceiptNo(rowdata.receipt_no)
                setBookingValidity(`${rowdata.tap_start_date} to ${rowdata.tap_end_date}`)
                setBookingTimeSlotList(res.data.response_data)
                setBookingTimeSlotListDetailView()
            }
        });

          setVisible(true);
      
    };
      
    const onSearch = (e) => {
      setFilteredSearchList([]);
      const string = e.target.value;
     // console.log("Clicked", jcpEnrollmentReceiptList);
  
  
      const x = props.tapBookingList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
  
  
      setFilteredSearchList(x)
    }
    

    useEffect(()=>{
      setFilteredSearchList(props.tapBookingList);
    },[props.tapBookingList])
  
  
    return (
      <>
        <CustomTableSearch onSearchTable={onSearch} style={{marginLeft: 0}} />
        <Table 
        columns={columns} 
        rowKey={commonUtility.randomID()} 
        dataSource={filteredSearchList} 
        pagination={{
          current: page,
          pageSize,
          onChange: (page) => setPage(page),
        }} 
        />



        <Drawer
            title="Schedule List"
            width="400px"
            onClose={onClose}
            visible={visible}
            bodyStyle={{
              paddingBottom: 80,
              background:'#FFF',
              border:0
            }}
            destroyOnClose = {true}
            className="customSideDrawer"
  
          >
            
            <div className="scheduleDrawerListView">
            
                {/* <h4>{ memberName } ({ memberMobileNo })</h4> */}
                <Card size="small" title="Member Details" bordered={false}>
                  <Row>
                    <Col span={8}>Name </Col>
                    <Col> : { memberName } </Col>
                  </Row>
                  <Row>
                    <Col span={8}>Receipt </Col>
                    <Col> : {receiptNo} </Col>
                  </Row>
                  <Row>
                    <Col span={8}>Booking Validity</Col>
                    <Col> : {bookingValidity} </Col>
                  </Row>
                </Card>
                
                {bookingTimeSlotList.length > 0
                                                        ? bookingTimeSlotList.map((booking_schedule) => {
                                                        
                                                          return (
                                                            
                                                            <>

                                                            <Card
                                                                key={commonUtility.randomID()}
                                                                size="small"
                                                                title={`${booking_schedule.day_name} ${booking_schedule.time_slot}`}
                                                                bordered={false}
                                                                style={{
                                                                  width: 'auto',
                                                                  marginTop:15,
                                                                  boxShadow:'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
                                                                 // box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
                                                                  borderRadius:0,
                                                                  background:'#f9f9f9'
                                                                }}
                                                               
                                                              >
                                                                
                                                                <Row>
                                                                  <Col span={8}><h4>Group</h4></Col>
                                                                  <Col span={16}><h4 style={{fontStyle:'italic'}}>{booking_schedule?.tap_group == "TAPM" ? 'TAP Morning' : 'Special Coaching'}</h4></Col>
                                                                </Row>

                                                                <Row>
                                                                  <Col span={8}><h4>Coach</h4></Col>
                                                                  <Col span={16}>
                                                                    <h4>
                                                                      {
                                                                        booking_schedule.tap_group != "TAPSC" ? <>{
                                                                          booking_schedule?.is_with_coach == "Y" ? "With Coach" : "Without Coach"
                                                                        }</> : ""
                                                                      }
                                                                      
                                                                      {/* {booking_schedule?.coach_master_id > 0 ? booking_schedule.coach_name : ""} */}
                                                                      {
                                                                        booking_schedule.coach_master_id > 0 ? booking_schedule?.coach_name + " - " + booking_schedule?.ratio_name + " - " + booking_schedule?.time_tag : ""
                                                                      }
                                                                    </h4>
                                                                  </Col>
                                                                </Row>

                                                                <Row>
                                                                  <Col span={8}><h4>Total Amount</h4></Col>
                                                                  <Col span={16}><h4>&#8377; {booking_schedule?.total_amount.toFixed(2)}/-</h4></Col>
                                                                </Row>

                                                                
                                                                <Row>
                                                                  <Col span={24}>
                                                                    <h4>Booked Date ({booking_schedule.no_of_days})</h4>
                                                                    <>
                                                                      <Space size={[8, 8]} wrap>
                                                                       {booking_schedule?.temp_dates?.split(',').map((step)=>  <Tag color="#f50" style={{margin:0}}>{step}</Tag>)}
                                                                      </Space>
                                                                    </>
                                                                  </Col>
                                                                </Row>
                                                                
                                                              </Card>


                                                            


                                                            </>


                                                        )})
                                                        : ""}
                

            </div>

          </Drawer>


      </>
    );
}


export default TapBookingListView